import React from 'react';
import './Landing.css';
import { Link } from "react-router-dom";

class Landing extends React.Component {

  componentDidMount() {
    var blink_speed = 2000;
    var wordArray = ['EXPLORE.', 'TOGETHER.', 'GREEN.'];
    var count=0;

    setInterval(function () {
      var ele = document.getElementById('flash');
      if(ele != null){
        ele.innerHTML = wordArray[count++];

        if(count===wordArray.length) {
          count=0;
        }
      }
    }, blink_speed);
  }

  render() {
    return (
      <div>
        <div className="bg-color"></div>

        <div className="container full-screen">
          <div className="row align-items-center inherit-height">
            <div className="col-lg-6 col-md-6 col-sm-10">
              <div className="card bg-transparent-landing text-white card_border">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <h1 className="card-title">LET'S GO</h1>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <h1 className="card-title"><b id="flash">GREEN.</b></h1>
                    </div>
                  </div> 
                  <div className="row">
                    <div className="col">
                      <p className="card-text">Asambe delivers africa-centric,<br/> innovative electric mobility solutions.</p>
                    </div>
                  </div>    
                  <div className="row pt-2">
                    <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12 pt-2">
                      <Link className="btn btn-block button-style mr-2 mt-2" to="/logistics">LOGISTICS</Link>
                    </div>
                    <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12 pt-2">
                      <Link className="btn btn-block button-style-2 mr-2 mt-2" to="/ride">RIDE</Link>
                    </div>        
                  </div>
                </div>
              </div>
            </div>
            <div className="col landing-div">
              <img className="landing-img" src={require('./resources/AFRONAUT_CROP.png')} alt="" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Landing;
